
const digest = 'ba46ec195edaca6d00d731073c87d58b81e4dae9fed0fc03f2b5ea4006826bb6';
const classes = {"wrapper":"_wrapper_1nn26_1"};
const css = `._wrapper_1nn26_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 40px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  